// ring-size-slider.js

function initRingSizeSlider() {
  const sliderEl = document.getElementById("RingSizeSlider");
  const outputEl = document.getElementById("RingSizeOutput");
  const checkboxes = document.querySelectorAll("#RingSizeCheckboxes input");

  // Abort if missing or already initialised
  if (!sliderEl || checkboxes.length === 0 || sliderEl.noUiSlider) return;

  const SIZE_ORDER = [
    "A","A ½","B","B ½","C","C ½","D","D ½","E","E ½","F","F ½",
    "G","G ½","H","H ½","I","I ½","J","J ½","K","K ½","L","L ½",
    "M","M ½","N","N ½","O","O ½","P","P ½","Q","Q ½","R","R ½",
    "S","S ½","T","T ½","U","U ½","V","V ½","W","W ½","X","X ½",
    "Y","Y ½","Z","Z ½","Z+1","Z+2","Z+3","Z+4","Z+5","Z+6"
  ];

  // Map & sort checkboxes to logical order
  let pairs = Array.from(checkboxes).map(cb => ({
    label: cb.value.trim(),
    cb
  })).sort((a, b) => SIZE_ORDER.indexOf(a.label) - SIZE_ORDER.indexOf(b.label));

  const labels = pairs.map(p => p.label);
  const sortedCheckboxes = pairs.map(p => p.cb);

  // Work out which sizes are currently active
  const checked = sortedCheckboxes
    .map((cb, i) => (cb.checked ? i : null))
    .filter(i => i !== null);

  const noFiltersActive = checked.length === 0;

  let startMin = 0;
  let startMax = labels.length - 1;

  if (!noFiltersActive) {
    startMin = Math.min(...checked);
    startMax = Math.max(...checked);
  }

  // Create slider
  noUiSlider.create(sliderEl, {
    start: [startMin, startMax],
    connect: true,
    step: 1,
    range: { min: 0, max: labels.length - 1 }
  });

  // Handle labels
  const handles = sliderEl.querySelectorAll(".noUi-handle");
  handles.forEach(handle => {
    const span = document.createElement("span");
    span.className = "handle-value";
    handle.appendChild(span);
  });

  // Live update
  sliderEl.noUiSlider.on("update", values => {
    const [minIdx, maxIdx] = values.map(v => parseInt(v, 10));

    sortedCheckboxes.forEach(cb => cb.checked = false);

    const fullRange = (minIdx === 0 && maxIdx === labels.length - 1);

    if (!fullRange) {
      for (let i = minIdx; i <= maxIdx; i++) {
        sortedCheckboxes[i].checked = true;
      }
    }

    handles[0].querySelector(".handle-value").textContent = labels[minIdx];
    handles[1].querySelector(".handle-value").textContent = labels[maxIdx];

    outputEl.textContent = fullRange
      ? "All sizes"
      : (minIdx === maxIdx ? labels[minIdx] : `${labels[minIdx]} – ${labels[maxIdx]}`);
  });

  // On release, submit form
  sliderEl.noUiSlider.on("change", () => {
    const [minIdx, maxIdx] = sliderEl.noUiSlider.get().map(v => parseInt(v, 10));
    const fullRange = (minIdx === 0 && maxIdx === labels.length - 1);

    if (!fullRange) {
      sortedCheckboxes.forEach(cb => {
        if (cb.checked) {
          cb.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    }

    setTimeout(() => {
      sortedCheckboxes[0].closest("form").requestSubmit();
    }, 20);
  });
}

// First page load
document.addEventListener("DOMContentLoaded", initRingSizeSlider);
